import React from 'react';
import {Router, hashHistory, Route, IndexRoute} from 'react-router';
import App from './components/App';
import Station from './components/Station/StationInfo';
import Home from './components/Home/Home';
import Basin from './components/Basin';
import StationImage from './components/Station/StationImage';
import CommunityOutreach from './components/CommunityOutreach';
import CurrentForecast from './components/CurrentForecast';
import Projects from './components/Projects';
import Publications from './components/Publications';
import HazardMap from './components/HazardMapLeaflet';
import RiverWatch from './components/Watch/RiverWatch';
import RainfallWatch from './components/Watch/RainfallWatch';

const NotFound = () => (
  <div className="spinner">
    <img className="img-responsive" src="http://azuretwilight.org/filedata/fetch?id=222" alt="not found"/>
  </div>
);

const Routes = () => (
  <Router history={hashHistory}>
    <Route path='/' component={App}>
      <IndexRoute component={Home}/>
      <Route path='basin' component={Basin}>
        <Route path=':id' component={Station}>
          <Route path='image' component={StationImage}/>
        </Route>
      </Route>
      <Route path="community_outreach" component={CommunityOutreach}/>
      <Route path="current_forecast" component={CurrentForecast}/>
      <Route path="projects" component={Projects}/>
      <Route path="publications" component={Publications}/>
      <Route path="flood_hazard_map" component={HazardMap}/>
      <Route path="river_watch" components={RiverWatch}/>
      <Route path="rainfall_watch" components={RainfallWatch}/>
      <Route path="*" component={NotFound}/>
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js